export default [
    {
        path: '/faq-item',
        props: true,
        component: () => import('@/views/FaqItem'),
    },
];